import { keyframes, query } from '@angular/animations';
import { Injectable } from '@angular/core';
import {ActivatedRoute, NavigationEnd, ParamMap, Route, Router} from '@angular/router';
import { RouteId } from 'src/app/enums/env/routes-id-enum';
import { DateKey, FiltersKey, StationKey } from 'src/app/enums/search-key.enum';
import { FilterByPage, FilterValue } from 'src/app/interfaces/filtres/filter-interface';
import { DateStartEndModel } from 'src/app/tinea-components/dateTime-picker/models/datesStartEndModel';
import { UserSessionService } from 'src/app/tinea-components/okta/services/session/user-session.service';
import {Subscription} from 'rxjs';
import {filter, map, startWith} from 'rxjs/operators';
import {Location} from '@angular/common';
import {RoutingService} from '../../../services/Routing.service';
import {environment} from '../../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class SearchService {

  currentUrl = '';
  subscription = new Subscription();
  constructor(
    private userSession: UserSessionService,
    private router: Router,
    private activeRoute: ActivatedRoute,
    private loc: Location
  ) {
  }
  static sortParamMap<T extends any>(paramMap: ParamMap): FilterValue<T>[] {
    // par default

    const filterValueTab: FilterValue<T>[] = [];
    // parcours de toutes les params,
    for (const key of paramMap.keys) {
      const filterValue = {value : '', key : <T>'' };
      filterValue.key = <T>key ;
      filterValue.value = paramMap.get(key);
      filterValueTab.push(filterValue);
    }
    return filterValueTab;
  }
  resetFilterOnChangePage() {
    return this.router.events.pipe(
        filter((event): event is NavigationEnd => event instanceof NavigationEnd),
        startWith(this.router),
        map(() => {
          const url = location.pathname.split('/')[1];
          if (this.currentUrl !== url) {
            this.userSession.clearSessionSearch();
            this.currentUrl = url;
          }
        }));
  }

  initSearch(routeId: RouteId): FilterByPage<any> {
    const searchValues =  this.getSearchByRouteId(routeId);
    if (!searchValues) {
      return {params: [{ value: '', key: FiltersKey.SEARCH }], type: routeId};
    }

    return searchValues.params.find((elm) => elm.key === FiltersKey.SEARCH)
        ? searchValues
        : Object.assign(searchValues, { params: [...searchValues.params, { value: '', key: FiltersKey.SEARCH }] });
  }

  changeQueryParamsUrl<T>(params: FilterValue<T>[]) {
    // création de l'objet pour le queryparam
    const paramsForLink: any  = {} as any;
    for (const param of params) {
      paramsForLink[param.key] = param.value;
    }

    this.router.navigate([], {
      queryParams: paramsForLink,
      queryParamsHandling: 'merge'
    });
  }

  changeQueryParamsSession<T>(params: FilterValue<T>[], routeId: RouteId ) {
    const filterByPage: FilterByPage<T> = {
      type : routeId,
      params : params,
    };

    this.changeFilterValueSession<T>(filterByPage);
  }

  // méthode sert à changer la valeur d'un filtre
  changeQueryParam<T>(searchVal: FilterValue<T>, routeId: RouteId) {
    // dans le tableau de tous les filtres des pages, on récupère les paramètres de la page courante
    const getAllFilterByPage = this.userSession.getSearch<T>().find(elm => elm.type === routeId) ?
        this.userSession.getSearch<T>().find(elm => elm.type === routeId).params : [];

    let params: FilterValue<T>[] = [];
    let searchValUpdate: FilterValue<T> = null;
    // si des paramètres existent sur cette page, on vérifie si le filtre de la recherche existe, si oui on modifie sinon on ajoute
    if (getAllFilterByPage) {
      searchValUpdate =  getAllFilterByPage.find(elm => elm.key === searchVal.key);

      if (searchValUpdate) {
        getAllFilterByPage[getAllFilterByPage.indexOf(searchValUpdate)].value = searchVal.value;
        params = getAllFilterByPage;
      } else {
        params.push(searchVal);
      }

    } else {
      // sinon on push la searchVal et on ajoute un nouveau filtre pour cette page
      params.push(searchVal);
    }

    // Store and change new value, in session and url
    this.changeQueryParamsSession<T>(params, routeId);
    this.changeQueryParamsUrl<T>(params);
  }

  // Store and get value in session

  changeFilterValueSession<T>(filterByPage: FilterByPage<T>) {
    this.userSession.storeSearch(filterByPage);
  }

  getSearchByRouteId<T>(routeId: RouteId): FilterByPage<T> | undefined {
    const allSearch = this.userSession.getSearch<T>();
    return allSearch.find(elm => elm.type === routeId);

  }

  changeDatesFilter(dates: DateStartEndModel, filterList: FilterValue<any>[], routeId: RouteId) {
    // si la page à des params
      const dateStartQuery = filterList.find(elm => elm.key === DateKey.DATESTART);
      const dateEndQuery = filterList.find(elm => elm.key === DateKey.DATEEND);
      // si le param date de la page existe
      // sinon on lui donne les valeurs par default
      if (dateStartQuery && dateEndQuery) {
        filterList[filterList.indexOf(dateStartQuery)].value = dates.dateStart;
        filterList[filterList.indexOf(dateEndQuery)].value = dates.dateEnd;
      } else {
        filterList.push({value : dates.dateStart, key: DateKey.DATESTART});
        filterList.push({value : dates.dateEnd, key: DateKey.DATEEND});
      }
      this.changeQueryParamsSession(filterList, routeId);
      this.changeQueryParamsUrl(filterList);
      return filterList;
    }

}
